import { createI18n } from "vue-i18n"
import { getEnv, getEnvArray } from "@/common/util/environment"

import en from "@/i18n/locales/en.json"
import de from "@/i18n/locales/de.json"
import es from "@/i18n/locales/es.json"
import fr from "@/i18n/locales/fr.json"
import zh from "@/i18n/locales/zh.json"
import ja from "@/i18n/locales/ja.json"

const i18n = createI18n({
  locale: getEnv("VITE_APP_DEFAULT_LOCALE") as string,
  fallbackLocale: getEnv("VITE_APP_FALLBACK_LOCALE") as string,
  legacy: false,
  availableLocales: getEnvArray("VITE_APP_SUPPORTED_LOCALES") as string[],
  messages: {
    en,
    de,
    es,
    fr,
    zh,
    ja,
  },
});

export default i18n;
